import Router from 'vue-router'
import Index from './pages/Index.vue'
const routes = [
  {
    path: '/',
    component: {
      render(h) {
        return h('div')
      }
    }
  },
  {
    path: '/home',
    component: Index
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/pages/search/Search.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/pages/detail/Index.vue')
  },
  {
    path: '/create',
    name: 'create',
    component: () => import('@/pages/create/Index.vue')
  },
  {
    path: '/preview',
    name: 'preview',
    component: () => import('@/pages/create/Preview.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/pages/questionnaire/Settings.vue')
  },
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: () => import('@/pages/questionnaire/Index.vue')
  },
  {
    path: '/create-item',
    name: 'createItem',
    component: () => import('@/pages/create/Create.vue')
  }
]

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes
})
